"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  portContacts: {
    portContacts: 'LOCAL CONTACT',
    company: 'Company',
    complaintCenter: 'Customer Complaint Center',
    issueTitle: 'Title',
    type: 'Type',
    issueDescription: 'Content',
    contentInfo: '### Data information（Required）\n' + '- Function page：\n' + '- Query conditions：\n' + '- Account number：\n' + '\n' + '### Problem Description（Incomprehensible work orders will be closed directly）\n',
    placeholderSA: 'input SA',
    titleIsNull: 'Title is null',
    typeIsNull: 'Type is null',
    contentIsNull: 'Content is null',
    photoTips: 'Drag the image to the upload button or click the upload button (supports JPEG, JPG, PNG, the image does not exceed 10M)',
    fileTips: 'Only upload word/excel/pdf & no more than 10M',
    fileIsLarge: 'The upload file size cannot exceed 10M!',
    fileNameIsLong: 'The upload file name cannot exceed 100 characters!',
    imageIsFalse: 'The uploaded image format is incorrect!',
    photoIsLarge: 'The upload image file size cannot exceed 10MB',
    tips_1: 'warm tips：',
    tips_2: 'Tips to improve issue response efficiency',
    tips_3: '(1) Must provide detailed data, screenshots, operation steps, incomplete issue cannot be processed',
    tips_3_1: '(2) Financial data package issues,Please check with the financial center of the headquarters first.The issue without confirmation screenshots will be closed directly',
    tips_4: 'The work order supports MD syntax formatting, pay attention to the readability of the content, and facilitate the reference of other questions',
    tips_5: 'Please limit the scope of the problem to the scope of existing functions',
    jobResponsibilities: 'Job Responsibilities',
    name: 'Name',
    responsibilities: 'Responsibilities',
    attachFile: 'Attach Files',
    createIssue: 'Submit',
    sureSubmit: 'Confirm submit ?',
    feedbackInfo: 'Feedback Information',
    success: 'Success'
  }
};